import { t } from '@hefe/i18n';
import { User } from '@hefe/models';
import { ModalsSlice, UsersSlice } from '@hefe/store';
import { fullUserName } from '@hefe/utils';
import { Space, Typography } from 'antd';
import { useMemo } from 'react';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface DeleteUsersFormProps {
  users: User[];
}

export default function DeleteUsersForm(props: DeleteUsersFormProps) {
  const { users } = props;
  const dispatch = useAppDispatch();

  const userIds = users.map((user) => user.id);

  const usersWithInventory = useMemo(() => {
    return users.filter((user) => user.inventories?.length);
  }, [users]);

  const submit = () => {
    const setLoading = ModalsSlice.modalsActions.setModalLoading;
    dispatch(setLoading(true));
    dispatch(UsersSlice.deleteMultiUsers(userIds))
      .unwrap()
      .then(() => dispatch(ModalsSlice.modalsActions.closeModal()))
      .catch(() => null)
      .finally(() => dispatch(setLoading(false)));
  };

  return (
    <Space direction="vertical">
      <Typography.Paragraph>
        {t('questions.delete_users', { count: userIds.length })}
      </Typography.Paragraph>
      {usersWithInventory?.map((user) => (
        <Typography.Paragraph type="warning">
          {t('errors.users.has_inventory', {
            name: fullUserName(user),
            inventoryList: user?.inventories?.map((i) => i.name).join(', '),
          })}
        </Typography.Paragraph>
      ))}
      <CustomForm
        key="delete-users"
        formId="delete-users"
        fields={[]}
        onSubmit={submit}
      />
    </Space>
  );
}
